import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DetailView from '../Common/DetailView';
import { Card, CardActions, CardHeader, CardText } from 'material-ui/Card';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';
import RaisedButton from 'material-ui/RaisedButton';
import SuccessSnackbar from "../Common/SuccessSnackbar";
import { clearAuthTokens, getAuthTokenCount } from "../../actions/UserActionCreator";
import buildContextMenu from '../Common/BuildContextMenu';
import StatStore from "../../stores/StatStore";
import { StatTypes } from "../../constants/CentricConstants";

class Housekeeping extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            count: 0,
            actions: buildContextMenu(this.getActions(), this.context.auth)
        };
    }

    componentDidMount() {
        this.listener = StatStore.addListener(() => this.setState({count: Number(StatStore.get(StatTypes.AUTH_TOKEN_COUNT))}));
        getAuthTokenCount();
    }

    componentWillUnmount() {
        this.listener.remove();
    }

    getActions() {
        return [
            {
                link: '/logout',
                icon: <CancelIcon />,
                label: 'Sign out',
            }
        ];
    }

    render() {
        return (
            <DetailView title="Housekeeping" actions={this.state.actions} >
                <div className="cent-cards">
                    <Card className="cent-card" >
                        <CardHeader title='Auth tokens' />
                        <CardText className="cent-card-text">
                            {`Clear ${this.state.count} user authorisation tokens`}
                        </CardText>
                        <CardActions>
                            <RaisedButton
                                className="button-raised"
                                key="btn_clear"
                                label="Clear"
                                onTouchTap={clearAuthTokens}
                                primary
                                disabled={this.state.count === 0}
                            />
                        </CardActions>
                    </Card>
                </div>
                <SuccessSnackbar/>
            </DetailView>
        );
    }
}

Housekeeping.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default Housekeeping;
